// extracted by css-extract-rspack-plugin
export default {"dragLayer":"jFrPR","preview":"GGWG3"};